module.exports = (__webpack_require__(56))(5);


//////////////////
// WEBPACK FOOTER
// delegated ./src/commonres/components/ocean/index.js from dll-reference vendor_254ec79b9eff2627f00f
// module id = 72
// module chunks = 7 8